import React from 'react';
import clsx from 'clsx';
import { Image, Loader } from 'semantic-ui-react';
import imagePlaceholder from '@/assets/images/image-placeholder.svg';

const setDefaultImage = ({ currentTarget }) => {
  const ct = currentTarget;
  ct.onerror = null;
  ct.src = imagePlaceholder;
};

const CollectionLogo = ({
  altText,
  className,
  floated,
  imageKey,
  isSaving,
  size = 'small',
  src,
  ui,
  wrapped,
}) => {
  if (isSaving) {
    return (<Loader active inline="centered" size="tiny" />);
  }
  return (
    <Image
      alt={altText}
      className={clsx('aridhia-collection-logo', className)}
      floated={floated}
      key={imageKey}
      onError={(e) => { setDefaultImage(e); }}
      size={size}
      src={src}
      ui={ui}
      wrapped={wrapped}
    />
  );
};

export default CollectionLogo;
